/**
 * @file catalog.provider.tsx
 * @description Провайдер компонента каталога для Task Manager приложения, который обеспечивает интеграцию контекста поиска с основным компонентом каталога. Выступает в роли обертки высшего порядка (HOC) для предоставления SearchTextContext всем дочерним компонентам каталога, обеспечивая централизованное управление состоянием поискового запроса и его синхронизацию между различными элементами интерфейса каталога (строка поиска, фильтры, таблица данных).
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['./context/search-text-context', './catalog.component']
 * @related-files ['src/features/catalog/catalog.component.tsx', 'src/features/catalog/context/search-text-context.tsx', 'src/features/catalog/components']
 */

import { SearchTextProvider } from "./context/search-text-context";
import { Catalog as CatalogMain } from './catalog.component';

export const Catalog = (props: React.ComponentProps<typeof CatalogMain>) => {
    return (
        <SearchTextProvider>
            <CatalogMain {...props} />
        </SearchTextProvider>
    );
};
